import { useNavigate } from "react-router-dom";

export default function ModuleCard({ data }) {
  const route_navigate = useNavigate();

  return (
    <>
      <div className="grid">
        {data.map((item, index) => (
          <div key={`card_${index}`} className="col-6 md:col-4">
            <div
              className="h-full border-1 border-400 border-round-md hover:text-blue-600 hover:bg-gray-100 cursor-pointer p-3"
              onClick={() => route_navigate(item.url)}
            >
              <div className="max-w-10rem mx-auto">
                <div
                  className="w-full bg-center bg-contain bg-no-repeat"
                  style={{
                    backgroundImage: item.img ? `url('${item.img}')` : "",
                    paddingBottom: "100%",
                  }}
                ></div>
              </div>
              <div className="text-center text-xl font-bold mt-3">
                {item.title}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
